export class HomeJSONIDService {
  public HomeBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "iQuanta",
  "image": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
  "url": "https://www.iquanta.in/",
  "telephone": "+917683043155",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ground Floor, 126, Udyog Vihar Phase 4 Rd, Phase III, Udyog Vihar, Sector 19",
    "addressLocality": "Gurugram",
    "postalCode": "122022",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.494521777065867,
    "longitude": 77.07957645211637
  },
  "priceRange": "51,499",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "opens": "00:00",
    "closes": "23:59"
  },
  "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/@CatpreparationiQuanta",
    "https://in.linkedin.com/company/iquanta-edu-services"
  ]
}

  public HomeOrganization =  {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "iQuanta",
  "alternateName": "iQuanta Edu",
  "url": "https://www.iquanta.in/",
  "logo": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "7683043155",
    "contactType": "customer service",
    "contactOption": "TollFree",
    "areaServed": "IN",
    "availableLanguage": ["en","Hindi"]
  },
  "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/@CatpreparationiQuanta",
    "https://in.linkedin.com/company/iquanta-edu-services"
  ]
}

  public HomePerson = {
  "@context": "https://schema.org/",
  "@type": "Person",
  "name": "Indrajeet Singh",
  "url": "https://www.iquanta.in/",
  "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
  "sameAs": [
    "https://www.facebook.com/IndrajeetiQuanta",
    "https://www.linkedin.com/in/indralion/"
  ],
  "jobTitle": "CEO",
  "worksFor": {
    "@type": "Organization",
    "name": "iQuanta"
  }
}

public HomeFAQ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "Which CAT course is best for non-engineers to prepare for CAT 2025?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can go for iQuanta flagship course CAT 2025 Full Course or the CAT 2025 Pro Batch. These courses provide conceptual videos for non-engineers, for those who are extremely weak in quant, and After completion of each topic, there is a marathon that carries questions of CAT 2023. We provide a topic-wise CAT mock test, 50 Questions on each Topic as Study Material and 10 + Sets of Hardcopy CAT Material as per the Updated Pattern (5000 Questions). The Course has 250+ Recorded Videos and practice sessions after each class along with 24x7 instant doubt support."
    }
  },{
    "@type": "Question",
    "name": "Is it necessary to opt for any CAT coaching?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "It depends on individual hard work and practice but having a mentor beside you can help you crack the exam easily. iQuanta is the best when it comes to content, study material or doubt resolution."
    }
  },{
    "@type": "Question",
    "name": "When should I join a CAT course?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Generally, there is no right time to join any CAT course. You can go for it while in college or after graduation depending on when you want to do your MBA."
    }
  },{
    "@type": "Question",
    "name": "Should I self-prepare or go with a CAT coaching?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can go with either depending on how familiar you are with aptitude tests. But the best combination would be CAT coaching along with self-study. Coaching will simplify your hunt for study material and structure your preparation. iQuanta’s CAT Course also ensures that all your doubts and instantly resolved. Meanwhile, self-practicing will help you in getting familiar with all types of questions."
    }
  },{
    "@type": "Question",
    "name": "Is CAT online coaching a good idea?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "CAT online coaching is pocket-friendly and easily accessible according to student convenience. It saves time as well as energy for students. iQuanta provides several online CAT courses which makes learning easy. You can go for the iQuanta CAT 2025 full course which involves conceptual videos for non-engineering students, topic-wise tests, assignments, full CAT mocks and a Crash Course in addition to a Live & application class with 24x7 doubt assistance."
    }
  },{
    "@type": "Question",
    "name": "Which CAT online coaching is helpful if I am weak in Quants?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "iQuanta’s CAT course is the right choice as it has a customised module for those who are extremely weak in Mathematics. This module is in alignment with the NCERT class 6-10 syllabus. So if you have lost touch with Mathematics or have not studied Maths after class 12 then this module is definitely for you. The Quant section has basic Maths that we have studied in class 6 to 10 such as number system, average, ratio & proportion, profit & loss, probability, geometry, time, work & distance, etc. So you will be taught all the topics from the basic concepts itself. So the iQuanta CAT course is really helpful for you if you are struggling with Mathematics."
    }
  }]
}

}